import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import OfferingsPage from "./pages/OfferingsPage";
import BookingPage from "./pages/BookingPage";
import EthicsPage from "./pages/EthicsPage";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 800);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="App min-h-screen bg-bg-primary text-text-primary">
      <AnimatePresence mode="wait">
        {isLoading ? (
          <motion.div
            key="loader"
            className="fixed inset-0 bg-bg-primary flex items-center justify-center z-[100]"
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3 }}
              className="text-brand-accent font-heading text-3xl tracking-tight"
            >
              Somale
            </motion.div>
          </motion.div>
        ) : (
          <BrowserRouter>
            <Navigation />
            <main>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/offerings" element={<OfferingsPage />} />
                <Route path="/book" element={<BookingPage />} />
                <Route path="/ethics" element={<EthicsPage />} />
              </Routes>
            </main>
            <Footer />
          </BrowserRouter>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
